import {styled} from "@mui/material/styles";
import { MenuItem } from '@mui/material';
import { MediaQuerys } from "../../../styles/GlobalStyle";
import { useColors } from "../../../Context/ColorsContext";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const { tablet, desktop } = MediaQuerys;

export const CustomMenuItem = styled(MenuItem)(() => {
    const { colors } = useColors();
    return {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '5px 10px',
        borderBottom: `1px solid ${colors.gray}`,
        color: colors.grayFont,
    
        '&.Mui-selected': {
            backgroundColor: 'transparent',
            fontWeight: 600,
        },
    
        '&.Mui-selected:hover': {
            backgroundColor: '#f5f5f5',
        },
    
        '&:last-of-type': {
            borderBottom: 'none',
        },
    }
})

export const CustomItem = styled('span')(({bold}) => ({
    paddingLeft: 6,
    fontWeight: bold ? 'bold' : 'normal',
    [desktop]: {
        fontSize: '0.75rem'
    }
}))

export const Image = styled('img')(() => ({
    width: '26px',
    [desktop]: {
        width: '1.5rem',
    },
    [tablet]: {
        width: '1.5rem',
    }
}))

export const ResponsiveTextLanguage = styled('span')(() => ({
    display: 'none',
    '@media (min-width: 700px)': {
        display: 'inline-block'
    }
}));

export const ResponsiveIconLanguage = styled(KeyboardArrowDownIcon)(() => ({
    display: 'none',
    '@media (min-width: 700px)': {
        display: 'block'
    }
}));

export const LanguageButton = styled('button')(({ theme, insideApp = true }) => {
    const { colors } = useColors();
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '6px',
        padding: '6px 12px',
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        cursor: 'pointer',
        minWidth: '120px',
        color: insideApp ? colors.gray : colors.black,
    
        '&:hover': {
            backgroundColor: insideApp ? colors.navbarColor : colors.gray ,
            opacity: 0.8
        },
        
        '@media (max-width: 699px)': {
            minWidth: 'auto',
            border: 'none',
            padding: '4px',
            '&:hover': {
                backgroundColor: 'transparent',
                opacity: 0.8
            }
        }
    }
});